import Box from '@mui/material/Box';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';


import { DateTime } from 'luxon';
import React from 'react';
import { useSelector } from 'react-redux';

import { Tracking } from 'common/models/trackings';
import { filterTrackings } from 'common/selectors/trackings';
import { AppState, userSelector } from 'common/store/store';
import { trackingSlice } from 'common/store/trackings';
import Grid from 'front/Grid';
import localStore from 'front/locaStorage';
import GridUtils from './GridUtils';


const gridId: string = 'trackingDataGrid';

export default (props: {}) => {



    const [ip, setIp] = React.useState('');
    const [filterSession, setFilterSession] = React.useState<string[]>([]);

    const filter = React.useMemo(
        () => (p: Tracking): boolean => {
            return (ip == '' || p.ip == ip) && (filterSession.length == 0 || (!!p.sessionId && filterSession.indexOf(p.sessionId) >= 0));
        },
        [ip, filterSession]
    );

    const user = useSelector((state: AppState) => userSelector.selectById(state, state.device.user?.id ?? 0));
    const [config, _setConfig] = localStore.useLocalStorage(gridId, {});
    const trackings = useSelector((state: AppState) => filterTrackings(state, filter));

    if (!user) return <></>;

    const columns: GridColDef<Tracking>[] = [
        GridUtils.baseColDef(config, {
            field: 'url',
            headerName: 'URL',
            editable: false,
        }),
        GridUtils.baseColDef(config, {
            field: 'query',
            headerName: 'Query',
            editable: false,
            renderCell: (params) => {
                return JSON.stringify(params.value);
            }
        }),
        GridUtils.baseColDef(config, {
            field: 'userAgent',
            headerName: 'UserAgent',
            editable: false
        }),
        GridUtils.baseColDef(config, {
            field: 'rcs',
            headerName: 'ReCaptcha Test',
            editable: false,
        }),
        GridUtils.baseColDef(config, {
            field: 'referer',
            headerName: 'Provenance',
            editable: false
        }),
        GridUtils.baseColDef(config, {
            field: 'sessionId',
            headerName: 'ID Appareil',
            editable: false
        }),
        GridUtils.baseColDef(config, {
            field: 'created',
            headerName: 'Date / temps',
            editable: false,
            renderCell: (params: GridRenderCellParams<Tracking>) => {
                return DateTime.fromMillis(params.row.created, { zone: 'utc' }).toLocal().toString();
            }
        }),
        GridUtils.baseColDef(config, {
            field: 'ip',
            headerName: 'IP',
            editable: false,
        }),
        GridUtils.baseColDef(config, {
            field: 'ips',
            headerName: 'IPs',
            editable: false,
            renderCell: (params: GridRenderCellParams<Tracking>) => {
                return params.row.ips?.join('/') ?? '';
            }
        }),

    ];


    return <Box sx={{ width: '100%' }}>
        <Grid
            modelName='trackings'
            disableColumnReorder
            gridId={gridId}
            rows={trackings}
            columns={columns}
            autoHeight={true}
            slice={trackingSlice}
            checkboxSelection
        />
    </Box>;
};
